import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer({ darkMode }) {
  const { t } = useTranslation(); // 引入 useTranslation 來進行翻譯

  return (
    <footer
      className={`py-8 ${
        darkMode
          ? 'bg-gray-800 text-gray-300'
          : 'bg-gray-100 text-gray-700'
      }`} // 深淺模式背景與文字顏色
      style={{ backdropFilter: 'blur(10px)' }} // 背景模糊效果
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between gap-8">
          {/* 快速導航 */}
          <div className="w-full sm:w-1/2 lg:w-1/5">
            <h3 className="text-lg font-bold mb-4">
              {t('quickLinks')}
            </h3>
            <ul>
              <li className="mb-2">
                <a
                  href="/about"
                  className="hover:underline transition duration-300"
                >
                  {t('aboutUs.title')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/services"
                  className="hover:underline transition duration-300"
                >
                  {t('services.title')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/report"
                  className="hover:underline transition duration-300"
                >
                  {t('reportSystem')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/wallet-risk"
                  className="hover:underline transition duration-300"
                >
                  {t('walletRiskQuery')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/become-partner"
                  className="hover:underline transition duration-300"
                >
                  {t('becomePartner')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/contact"
                  className="hover:underline transition duration-300"
                >
                  {t('contactUs.title')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/update-log"
                  className="hover:underline transition duration-300"
                >
                  {t('updateLogs')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/faqs"
                  className="hover:underline transition duration-300"
                >
                  {t('faqs.title')}
                </a>
                </li>
            </ul>
          </div>

          {/* 隱私政策與條款 */}
          <div className="w-full sm:w-1/2 lg:w-1/5">
            <h3 className="text-lg font-bold mb-4">
              {t('legalAndPolicy')}
            </h3>
            <ul>
              <li className="mb-2">
                <a
                  href="/privacy-policy"
                  className="hover:underline transition duration-300"
                >
                  {t('privacyPolicy.title')}
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/privacy-policy#terms-of-service"
                  className="hover:underline transition duration-300"
                >
                  {t('termsOfService.title')}
                </a>
              </li>
            </ul>
          </div>

          {/* 社交媒體 */}
          <div className="w-full sm:w-1/2 lg:w-1/5">
            <h3 className="text-lg font-bold mb-4">
              {t('socialMedia')}
            </h3>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/damen-kyt/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition duration-300"
              >
                <i className="fab fa-linkedin-in text-2xl"></i>
              </a>
              <a
                href="https://x.com/DamenKYT"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition duration-300"
              >
                <i className="fab fa-twitter text-2xl"></i>
              </a>
              <a
                href="https://t.me/+bHic2HDBdyVmOTg1"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition duration-300"
              >
                <i className="fab fa-telegram-plane text-2xl"></i>
              </a>
            </div>
          </div>
          
          {/* 捐款（暫時隱藏）
          <div className="w-full sm:w-1/2 lg:w-1/5">
            <h3 className="text-lg font-bold mb-4">
              {t('donation')}
            </h3>
            <ul>
              <li className="mb-2">
                <a
                  href="/donation"
                  className="hover:underline transition duration-300"
                >
                  <span 
                    style={{
                      background: 'linear-gradient(to right, #FF8C00, #FFA500)', 
                      WebkitBackgroundClip: 'text',
                      backgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      fontWeight: '800',
                      fontSize: '1.05rem',
                      padding: '0.1rem 0.5rem',
                      border: '1px solid rgba(255, 140, 0, 0.3)',
                      borderRadius: '4px',
                      boxShadow: '0 1px 3px rgba(255, 140, 0, 0.2)'
                    }}
                  >
                    {t('supportUs')}
                  </span>
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/donation-transparency"
                  className="hover:underline transition duration-300"
                >
                  {t('donationTransparency')}
                </a>
              </li>
            </ul>
          </div>
          */}
        </div>

        {/* 聯繫我們 */}
        <div className="mt-6 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
          <p className="font-semibold">{t('contactInfo')}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <span>大門科技顧問有限公司</span>
            <span>90512636</span>
            <span><a href="https://www.damentec.com/" className="hover:underline">{t('companyWebsite')}</a></span>
            <span>{t('customerEmail')}: <a href="mailto:barrywang.blockmen@gmail.com" className="hover:underline">barrywang.blockmen@gmail.com</a></span>
          </div>
        </div>

        {/* 版權聲明 */}
        <div className="text-center pt-6 border-t border-gray-700 mt-8">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Damen All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
